import { get, req, post } from '@/plugins/axios'
import md5 from 'md5'
import { queryAbnormalOrder, countAbnormalOrderCount } from '@/apis/order'
import { CountriesEnum, Site, Term, BizType, UseType } from '@/common/const'
import { getNoticeCount } from '@/apis/inShipping'
import { platType } from '@/plugins/tripartite-login'

export declare interface res<T = any> {
  success: boolean;
  code?: string;
  msg?: string;
  data?: T;
}

// 第三方平台绑定账号列表
export interface BindListItem {
  createTime: string;
  creatorId: number;
  customerId: number;
  editorId: number;
  id: number;
  isDelete: number;
  thirdCustomerId: string;
  thirdCustomerName: string;
  thirdEmail: string;
  thirdPhoneNumber: string;
  thirdPlatform: string;
  updateTime: string;
}

interface IsBindParams {
  customerId?: number;
  thirdCustomerId?: string;
  thirdPlatform?: string;
}

interface CancelBindParams {
  thirdCustomerId?: string;
  thirdPlatform: string;
}

interface ThirdParams {
  customerId: number;
  thirdCustomerId: string;
  thirdPlatform: string;
}
// 验证注册用户名
export const checkLoginName = (loginName: string): Promise<res> =>
  get('/customer/signup/check/loginname', {
    params: { loginName }
  })

/** 获取注册验证码 */
export const getSignupCode = (
  customerEmail: string,
  countryPlaceCode: CountriesEnum
): Promise<res> =>
  post('/customer/signup/send/code', { customerEmail, countryPlaceCode })

export type MobileCodeParams = {
  customerMobile: string;
  globalRoaming: string;
  bizType: BizType; // 1注册 2重置密码 3登录 4 修改手机号
  countryPlaceCode: CountriesEnum|any;// 这个确定下传不传，用于确定模版内容和国际化。直接取站点是否可以
  nationCode?: string;//  站点信息 英国日本韩国
  recaptchaCode?: string;
}

/**  获取手机验证证码 */
export const getMobileCode = (data: MobileCodeParams): Promise<res> =>
  post('/customer/mobile/send/code', data)

export const updateMobile = (data:any):Promise<res> =>
  post('/customer/changeMobile', data)

// 注册
export declare interface SD extends Record<string, any> {
  gender?: number;
  verificationCode?: string;
  countryCode?: string;
  customerMobile?: string;
  chatWorkId?: string;
  skype?: string;
  isagree?: boolean;
  invitationPlatform?: string;
  invitationCode?: string;
  channel?: string;
  spm?: string;
  countryPlaceCode?: CountriesEnum|string;
  utcTimeZone?: string;
  termId: string;
  /** 0直采 1代采 */
  buType:0|1;
  /** 1网页端,2APP,3插件,4H5 */
  platformType:1|2|3|4
}

export const signup = (data: SD): Promise<res> => {
  console.log(data, '??')
  return post('/customer/signup', { ...data })
}

type A = Omit<SD, 'termId'>;
// 激活子账号
interface ASD extends A {
  customerShopId: string;
}
export const activateSub = (data: ASD): Promise<res> =>
  post('/customer/customer/shop/activateSubCustomer', {
    ...data,
    customerStatus: 1,
    password: md5(data.password)
  })

// 默认平台
interface SDD {
  uuid: string;
  systemSource: number;
}
export const setDefault = (data: SDD): Promise<res> =>

  post('/customer/signup/defaultLogin', data)

export const setLaterDefault = (data: SDD): Promise<res> =>
  post('/customer/systemSourceLogin', data)

// 密码登录
export interface LPD {
  nameOrEmail: string;
  password: string;
  thirdCustomerId?: string;
  thirdPlatform?: string;
}

interface TripartitePlatfromParams {
  thirdPlatform: string;
  thirdCustomerId: string;
}

export const loginByPwd = (data: LPD): Promise<res> => {
  return post('/customer/passwordLogin', {
    ...data,
    password: data.password && md5(data.password)
  })
}

export const loginByTripartitePlatfrom = (
  data: TripartitePlatfromParams
): Promise<res> => post('/customer/passwordLogin', data)

// 获取登录邮箱验证码
export const getLoginCode = (customerEmail: string): Promise<res> =>
  post('/customer/emailLogin/send/code', { customerEmail })

// 邮箱验证登录
export interface LCD {
  customerEmail: string;
  verificationCode: string;
  thirdCustomerId?: string;
  thirdPlatform?: string;
}
/** 邮箱验证码登录 */
export const loginByCode = (data: LCD): Promise<res> =>
  post('/customer/emailLogin', data)

export interface LGM {
  countryCode: string;
  customerMobile: string;
  verificationCode: string;
  thirdCustomerId?: string;
  thirdPlatform?: string;
}
/** 手机验证码登录 */
export const mobileLogin = (data: LGM): Promise<res> =>
  post('/customer/mobileLogin', data)

// 获取用户
export const getUser = (token: string): Promise<res> =>
  req('/customer/getCustomerDetails?_t' + Math.random(), { token })

// 用户退出
export const logout = (): Promise<res> => get('/customer/logout')

// 更改用户信息
interface UUD {
  chatWorkId: string;
  countryCode: string;
  customerMobile: string;
  gender: number;
  skype: string;
  systemSource: number;
  customerName: string;
}
export const updateUser = (data: UUD): Promise<res> =>
  post('/customer/updateCustomer', data)

// 注销子账号
interface CSD {
  customerId: string;
}
export const cancelSubUser = (data: CSD): Promise<res> =>
  req('/customer/cancelSubCustomer', data)

// 更改邮箱发送邮件
export const getChangeEmailCode = (newCustomerEmail: string): Promise<res> =>
  get('/customer/changeEmailsendEmail', {
    params: { newCustomerEmail }
  })

// 更改邮箱
interface UED {
  newCustomerEmail: string;
  verificationCode: string;
}
export const updateEmail = (data: UED): Promise<res> =>
  post('/customer/changeNewEmail', { ...data })

// 原密码重置密码
interface UPD {
  oldPassword: string;
  newPassword: string;
  customerId?: string;
}
export const updatePassword = (data: UPD): Promise<res> =>
  post('/customer/updatePassword', {
    newPassword: md5(data.newPassword),
    oldPassword: md5(data.oldPassword),
    customerId: data.customerId
  })

// 忘记密码发送邮件
export const getForgotCode = (customerEmail: string): Promise<res> =>
  get('/customer/forgetPasswordSendEmail', {
    params: { customerEmail }
  })

// 忘记密码重置密码
export type UPBED = {
  /** 用户邮箱 */
  customerEmail?: string;
  /** 验证码 */
  verificationCode: string;
  newPassword: string;
  repassword: string;
  /** 手机区域码 */
  countryCode?: string;
  /** 用户手机号 */
  customerMobile?: string;
  /** 国家码 */
  nationCode?: string;
  /** 人机验证码 */
  recaptchaCode: string;
  globalRoaming:string;
  countryPlaceCode?: CountriesEnum | '';
}
export const updatePasswordByEmail = (data: UPBED): Promise<res> =>
  post('/customer/forgetPasswordResetPassword', {
    ...data,
    newPassword: md5(data.newPassword)
  })

// 切换2b与2c
export const changeB2C = (): Promise<res> => post('/customer/changeLogin')

// 切换店铺
export const changeShop = (val: number): Promise<res> =>
  req('/customer/changeShop', { shopId: val })

// 注销主账号
export const cancelUser = (data: any): Promise<res> =>
  req('/customer/cancelCustomer', data)

// 注销主账号前校验
export const cancelCustomerVerify = (data: any): Promise<res> =>
  req('/customer/cancelAllCustomerCheck', data)

// 注销子账号前校验
export const cancelSubCustomerVerify = (data: any): Promise<res> =>
  req('/customer/cancelSubCustomerCheck', data)
// 未处理异常订单
export const getNotProcessedOrder = (): Promise<any> => {
  return new Promise((resolve) => {
    countAbnormalOrderCount({})
      .then((res: any) => {
        if (res.success) {
          resolve(res.data)
        } else {
          throw new Error(res)
        }
      })
      .catch((err: any) => {
        throw new Error(err)
      })
  })
}
// 国际发货管理
export const getShippingListNum = (): Promise<any> => {
  return new Promise((resolve) => {
    getNoticeCount({})
      .then((res: any) => {
        if (res.success) {
          resolve(res.data ?? {})
        } else {
          throw new Error(res)
        }
      })
      .catch((err: any) => {
        throw new Error(err)
      })
      .then((res: any) => {
        if (res?.success) {
          resolve(res.data?.total ?? 0)
        } else {
          throw new Error(res)
        }
      })
      .catch((err: any) => {
        throw new Error(err)
      })
  })
}

// 是否已读建议修改密码弹窗
export function passwordChangeFlag () {
  return get('/customer/passwordChangeFlag')
}

// 已读建议修改密码弹窗
export function updatePasswordChange () {
  return get('/customer/update/passwordChangeFlag')
}

// 验证推广码是否为推广联盟
export const checkInvitationCode = (
  params: any
): Promise<{
  success: boolean;
  data: boolean;
}> => {
  return get('/customer/signup/check/invitationCode', { params })
}

// 获取推广码的站点信息
export const getInvitationInfo = (params: any) => {
  return get('/customer/signup/getInvitationInfo', { params })
}

/** 移出白名单 - 只限于APP使用 */
export const removeWhileList = (data: any) => {
  return post('/customer/removeWhileList', data)
}

/** 查询当前站点配置的登录背景图片url */
export const registerPageImageQuery = <Val, R>(params: {
  stationCode: Site;
}) => {
  return get<Val, R>('/customer/base/registerPageImage/getRegisterImage', {
    params
  })
}

/**
 * 用户同意条款
 * @param {termId, argeeTime} params
 * @param termId 条款id
 * @param argeeTime 同意时间
 * @returns
 */
export const agreeTerm = (params: { termId: string }) => {
  return get('/customer/base/term/agreeTerm', {
    params
  })
}

/**
 * 获取条款配置
 * @param params
 * @returns
 */
export const getEffectTermByType = (params: {
  type: Term;
  stationCode?: Site;
}) => {
  return get('/customer/base/term/getEffectTermByType', {
    params
  })
}

/**
 * 三方授权链接获取
 * @param data
 * @returns
 */
export const thirdAuthLink = (data: {
  thirdPlatform: platType;
  redirectUrl: string;
}): Promise<res> => {
  return post('/customer/thirdAuthLink', {
    ...data
  })
}

/**
 * 获取三方数据
 * @param data
 * @returns
 */
export const thirdData = (data: {
  authCode: string;
  redirectUrl: string;
  state: string;
  thirdPlatform: platType;
  email?: string;
  idTokend?: string;
  username?: string;
}): Promise<res> => {
  return post('/customer/thirdData', {
    ...data
  })
}

/** 获取已绑定三方登录平台list */
export const getBindList = () => {
  return get<res<BindListItem[]>>('/customer/bind/third/getBindList')
}

/** 判断某个第三方平台是否已经绑定过我们的账号 */
export const isBind = (data: IsBindParams) => {
  return post<res<{
    isBind: boolean;
    isNew: boolean;
  }>>('/customer/bind/third/isBind', data)
}

/** 账号管理 解除第三方绑定 */
export const cancelBind = (data: CancelBindParams) => {
  return post<res<boolean>>('/customer/bind/third/cancel', data)
}

/**
 * 检测货盘白名单
 * @param params
 * @returns
 */
export const checkPalletWhite = (): Promise<res> => {
  return get('/customer/checkPalletWhite')
}

/** 账号管理快捷绑定三方 */
export const third = (data: ThirdParams) =>
  post<res<boolean>>('/customer/bind/third', data)

interface addEmailParams {
  'newCustomerEmail':string,
  'verificationCode':number
}
/** 新增编辑邮箱 */
export const addEmail = (data:addEmailParams): Promise<res> => {
  return post('/customer/addEmail', { ...data })
}

/** 切换用户token */
export const changeLoginByType = (params: { type: UseType }): Promise<res> => {
  return get('/customer/changeLoginByType', {
    params
  })
}
